var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.354 2a.5.5 0 01.5-.5h2.815a.5.5 0 01.5.5v.423H5.354V2zm-1 .423V2a1.5 1.5 0 011.5-1.5h2.815a1.5 1.5 0 011.5 1.5v.423h3.351a.5.5 0 010 1h-.963l-.255 8.65a2.5 2.5 0 01-2.498 2.426H4.709a2.5 2.5 0 01-2.499-2.426l-.255-8.65H1a.5.5 0 010-1h3.354zm-1.398 1h8.6l-.253 8.62a1.5 1.5 0 01-1.5 1.456H4.71a1.5 1.5 0 01-1.5-1.456l-.253-8.62zm2.862 1.171a.5.5 0 01.5.5v5.779a.5.5 0 11-1 0V5.094a.5.5 0 01.5-.5zm3.387.5a.5.5 0 00-1 0v5.779a.5.5 0 101 0V5.094z",
    fill: "#EC4652"
  })));
}
export default SvgDelete;